import type { ComponentType } from 'react';
import { Maintenance } from 'views/system/Maintenance';

type AppRoute = {
  path: string;
  view: ComponentType;
  layout: string;
  title: string;
  permission?: string;
};

const routes: AppRoute[] = [
  {
    path: '/maintenance',
    view: Maintenance,
    layout: 'home',
    title: 'Maintenance',
  },
];

export default routes;
